import { render } from "./FeedsRequestsColumn.vue?vue&type=template&id=ec81536c&ts=true&lang=pug"
import script from "./FeedsRequestsColumn.vue?vue&type=script&lang=ts"
export * from "./FeedsRequestsColumn.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__